import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Resources from "@/components/Resources";
import Portfolio from "@/components/Portfolio";
import Community from "@/components/Community";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Hero />
      <About />
      <Resources />
      <Portfolio />
      <Community />
      <Footer />
    </div>
  );
};

export default Index;